import React from 'react';
import { AdminSection, TeacherSection, Segment } from '../models/timeline';

type FlexOptionComponentProps = {
  options: Segment[];
  children: (props: {
    segment: Segment;
    sections: (AdminSection | TeacherSection)[];
    timelineClassName?: string;
  }) => React.ReactNode;
  openModal?: (modal: string, params: any) => void;
  timelineId: string;
  onFlexOptionToggle?: (option: Segment) => void;
  customizable?: boolean;
};

const ConditionalFlexOptionWrapper = ({
  FlexOptionComponent,
  segment,
  children,
  openModal,
  timelineId,
  onFlexOptionToggle,
  customizable,
}: {
  FlexOptionComponent: React.ComponentType<FlexOptionComponentProps>;
  segment: Segment;
  children: (props: {
    segment: Segment;
    sections: (AdminSection | TeacherSection)[];
    timelineClassName?: string;
  }) => React.ReactNode;
  openModal?: (modal: string, params: any) => void;
  timelineId: string;
  onFlexOptionToggle?: (option: Segment) => void;
  customizable?: boolean;
}) => {
  const { options, sections } = segment;

  if (!segment.isFlex && !options?.length) return children({ segment, sections });

  if (!options?.length) return null;
  return (
    <FlexOptionComponent
      options={options}
      openModal={openModal}
      timelineId={timelineId}
      onFlexOptionToggle={onFlexOptionToggle}
      customizable={customizable}
    >
      {children}
    </FlexOptionComponent>
  );
};

export default ConditionalFlexOptionWrapper;
